import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=dbfca7d2&scoped=true&"
import script from "./not-found.component.ts?vue&type=script&lang=ts&"
export * from "./not-found.component.ts?vue&type=script&lang=ts&"
import style0 from "./not-found.scss?vue&type=style&index=0&id=dbfca7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfca7d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbfca7d2')) {
      api.createRecord('dbfca7d2', component.options)
    } else {
      api.reload('dbfca7d2', component.options)
    }
    module.hot.accept("./not-found.vue?vue&type=template&id=dbfca7d2&scoped=true&", function () {
      api.rerender('dbfca7d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/not-found/not-found.vue"
export default component.exports